import React from 'react';
import { Typography } from 'ha/ui/next/Typography';
import { withIntl, IntlProps } from 'ha/i18n';

import { GenderValue, GenderFilterValue } from 'ha/types/SearchFilters';
import Grid from 'ha/ui/next/Grid';

import FilterCheckbox from './FilterCheckbox';

interface Props {
  gender: GenderFilterValue;
  onToggle: (type: string, selected: boolean) => void;
}

export const GenderFilter: React.FC<Props & IntlProps> = ({
  gender,
  onToggle,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography.ParagraphTitle data-test-locator="GenderFilter Title">
      {T('Gender')}
    </Typography.ParagraphTitle>
    <Grid container>
      <Grid item md={6}>
        <FilterCheckbox
          name={`${GenderValue.BOYS}-checkbox`}
          isActive={gender.includes(GenderValue.BOYS)}
          onToggle={(selected: boolean) => onToggle(GenderValue.BOYS, selected)}
          data-test-locator="Filter Male"
        >
          <Typography.Paragraph noWrap>{T('Male')}</Typography.Paragraph>
        </FilterCheckbox>
      </Grid>
      <Grid item md={6}>
        <FilterCheckbox
          name={`${GenderValue.GIRLS}-checkbox`}
          isActive={gender.includes(GenderValue.GIRLS)}
          onToggle={(selected: boolean) =>
            onToggle(GenderValue.GIRLS, selected)
          }
          data-test-locator="Filter Female"
        >
          <Typography.Paragraph noWrap>{T('Female')}</Typography.Paragraph>
        </FilterCheckbox>
      </Grid>
    </Grid>
  </React.Fragment>
);

export default withIntl(GenderFilter);
